import { reevaluateUserIdentityConflict } from '~src/app/actions/spaces/UserIdentityActions';
import { IUserIdentityConflictInfo } from '~src/authentication/models/IUserIdentityConflictInfo';

import { AppState } from '../../../../app/state/AppState';
import { Messages } from '../../../../codegen/Localize';
import { EntityActionNames, IEntityAction } from './IEntityAction';

export const ReevaluateUserIdentityConflictAction: IEntityAction<IUserIdentityConflictInfo, {}> = {
  name: EntityActionNames.ReevaluateUserIdentityConflict,
  translateName: Messages.identityMigration_ReevaluateUserIdentityConflict,
  isVisible: (targetItems: IUserIdentityConflictInfo[], state: AppState) => areAllConflictsAcknowledged(targetItems),
  isClickable: (availableActions: {}, targetItems: IUserIdentityConflictInfo[], state: AppState) => areAllConflictsAcknowledged(targetItems),
  createReduxAction: (targetItems: IUserIdentityConflictInfo[]) => reevaluateUserIdentityConflict(targetItems)
};

function areAllConflictsAcknowledged(targetItems: IUserIdentityConflictInfo[]): boolean {
  return targetItems.every(x => x.acknowledged);
}
